import { render, staticRenderFns } from "./BulkAccount.vue?vue&type=template&id=4ce52773&"
import script from "./BulkAccount.vue?vue&type=script&lang=js&"
export * from "./BulkAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports